import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { onMounted, reactive, toRefs } from "vue";
import apis from "@/api";
export default {
  name: "nav-tree",
  components: {},
  setup() {
    const defaultProps = {
      label: "nodeName",
      children: "children"
    };
    const data = reactive({
      defaultExpandedeys: ["001", "002"],
      onlineLoading: true,
      offlineLoading: true
    });
    const initTree = type => {
      apis.queryPositionTree(type).then(res => {
        if (res.success) {
          data.position[type] = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        if (type === "online") {
          data.onlineLoading = false;
        } else if (type === "offline") {
          data.offlineLoading = false;
        }
      });
    };
    const loadNodeOnline = (node, resolve) => {
      if (node.level === 0) {
        return resolve([{
          nodeName: '互联网渠道物料',
          id: '001',
          leaf: 0
        }]);
      }
      if (node.level > 0) {
        getChild(node.data.id, resolve);
      }
    };
    const loadNodeOffline = (node, resolve) => {
      if (node.level === 0) {
        return resolve([{
          nodeName: '宣传设计制作物料',
          id: '002',
          leaf: 0
        }]);
      }
      if (node.level > 0) {
        getChild(node.data.id, resolve);
      }
    };
    const loadNodeOfflinePut = (node, resolve) => {
      if (node.level === 0) {
        return resolve([{
          nodeName: '线下投放排期表',
          id: '002',
          leaf: 0
        }]);
      }
      if (node.level > 0) {
        getChild(node.data.id, resolve);
      }
    };
    const getChild = (pId, resolve) => {
      apis.queryPositionChild(pId).then(res => {
        if (res.success) {
          if (res.data.length > 0) {
            res.data.forEach(val => {
              val.isLeaf = val.positionType == 2 ? 1 : 0;
            });
          }
          resolve(res.data);
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    onMounted(() => {
      /* initTree("online");
       initTree("offline");*/
    });
    return {
      ...toRefs(data),
      defaultProps,
      loadNodeOnline,
      loadNodeOffline,
      loadNodeOfflinePut,
      getChild
    };
  }
};